import React from 'react'
import Images from '../assets/images/Images';
import { getRedirectEnv } from '../services/Utils';

const AutopayBlocked = ({show, setShow, submitPayment, GoBack}) => {
    return (
        show &&
        <>
            <div onClick={() => {setShow(false); GoBack()}}className="modal fade show" style={{ display: "block" }} id="PaymentDisclaimer" tabIndex="-1" aria-labelledby="PaymentDisclaimerLabel">
                <div onClick={(e) => e.stopPropagation()} className="modal-dialog modal-dialog-centered modal-lg" style={{display: "flex", justifyContent: "center"}}>
                    <div className="modal-content quick-mc" style={{marginLeft: "0px", marginRight: "0px", maxWidth: "500px", maxHeight: "300px", height: "300px", padding: "15px", position: "relative"}}>
                        <p style={{position: "absolute", right: "15px", top: "10px", color: "#366898", cursor: "pointer"}} onClick={() => {setShow(false); GoBack()}}>CLOSE</p>
                        <div className="quick-modal-body" style={{ color: "#046ab0", width: "100%", height: "100%"}}>
                            <div className="container-fluid" style={{width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-around", alignItems: "center", paddingBottom: "0px", textAlign: "center"}}>
                                <p style={{color: "black", marginBottom: "0px"}}>
                                    You cannot enroll in or update Autopay this close to your upcoming due date.
                                </p>
                                <p style={{color: "black", marginBottom: "0px"}}>
                                    Please make a one time payment here for your current bill.
                                </p>
                                <button onClick={() => {setShow(false); submitPayment()}}style={{backgroundColor: "#ff8000", color: "white", padding: "6px", borderRadius: "12px", border: "none", outline: "none", alignSelf: "center"}}>Make a Payment</button>
                                <p style={{color: "black", fontWeight: "bold", alignSelf: "center", marginBottom: "0px"}}>
                                    You can manage Autopay 48 hours after your due date.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    )
}

export default AutopayBlocked